// extracted by mini-css-extract-plugin
export default {"root":"AddOnCredits_root__EYTYO","link":"AddOnCredits_link__YxcZl"};